import { Box, Theme } from '@mui/material';

/** Lightweight shell rendered during chunk loading. No feature imports. */
function ViewerSkeleton() {
    return (
        <Box
            sx={{
                backgroundColor: (theme: Theme) => theme.palette.surface.overlay,
                display: 'grid',
                gridTemplateAreas: `"top top" "left main"`,
                gridTemplateColumns: '15% 1fr',
                gridTemplateRows: '60px 1fr',
                height: '100vh',
                width: '100vw',
            }}
        >
            <Box sx={{ backgroundColor: 'theme.palette.background.paper', gridArea: 'top' }} />
            <Box sx={{ backgroundColor: (theme: Theme) => theme.palette.surface.overlay, gridArea: 'left' }} />
            <Box sx={{ backgroundColor: 'theme.palette.background.default', gridArea: 'main' }} />
        </Box>
    );
}

export default ViewerSkeleton;
